import SectionHeader from "@/elements/Sectionheader";
import { TestimonialsSectionProps } from "@/interfaces";
import { useEffect, useRef, useState } from "react";
import VideoTestimonial from "../VideoTestimonial";
import SuccessStoryCard from "../Successstorycard";
import TestimonialsCard from "../Testimonialscard";
import "./index.scss";
import SideModal from "../Modals/SideModal";
import TypoGraphy from "@/typography";
import useViewType from "@/utils/Hooks/useViewType";
import { projectImages } from "../../../public/Assets/Images";
import { apiService } from "@/services/apiService";
import { API_ENDPOINTS } from "@/services/endPoints";
export const testimonialVariants = {
  VIDEOCARD: "videocard",
  SUCCESSSTORY: "successstory",
  TESTIMONIAL: "testimonial"
};
export type TestimonialVariants = keyof typeof testimonialVariants;
const TestimonialsSection = ({
  title,
  type,
  data
}: TestimonialsSectionProps) => {
  const [showmodal, setShowModal] = useState(false);
  const [showAll, setshowAll] = useState(false);
  const [scrollState, setScrollState] = useState({
    disableLeft: true,
    disableRight: false
  });
  const testimonialRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [element, setElement] = useState<Element | null>(null);
  const isMobile = useViewType();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [touched, settouched] = useState(false);
  const [playing, setplaying] = useState<number>(0);
  const [restData, setrestData] = useState<any>([]);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const currentElement = element;
    const handleScroll = (e: any) => {
      if (e?.currentTarget?.children && currentElement) {
        let width = e?.currentTarget?.children[0]?.clientWidth;
        const left = currentElement?.scrollLeft;
        let max = currentElement.scrollWidth - currentElement.clientWidth;
        setScrollState({
          disableLeft: !(left > width),
          disableRight: left > max - (width - 36)
        });
      }
    };
    currentElement?.addEventListener('scroll', handleScroll);

    // Cleanup function
    return () => {
      currentElement?.removeEventListener('scroll', handleScroll);
    };
  }, [element]);
  useEffect(() => {
    const observer = new IntersectionObserver(async (entries: any) => {
      if (entries[0].isIntersecting) {
        let response: any;
        switch (type) {
          case "SUCCESSSTORY":
            response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getTransitions()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
            break;
          case "VIDEOCARD":
            response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getVideoTestimonials()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
            break;
          case "TESTIMONIAL":
            response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getTestimonials()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
            break;
        }
        if (!showAll) {
          const skipCount = type === "VIDEOCARD" ? 5 : 4;
          const rest = response.data.slice(skipCount);
          setrestData(rest);
          setshowAll(true);
        }
      }
    }, {
      threshold: 0
    });
    if (testimonialRef.current) {
      observer.observe(testimonialRef.current);
    }
    return () => {
      observer.disconnect(); // Properly disconnect observer
    };
  }, [testimonialRef, type, data]);
  const getModalData = () => {
    switch (type) {
      case "SUCCESSSTORY":
        return [...data?.data, ...restData]?.map((element: any, index: number) => {
          let item = element.attributes;
          return <div className="testimonial_item_wrapper" key={`success_story_${index}`}>
                <SuccessStoryCard learnerDetails={item} isModal={true} />
              </div>;
        });
      case "TESTIMONIAL":
        if (data) {
          return [...data?.data, ...restData].map((element: any, index: number) => {
            let item = element.attributes;
            return <div className="testimonial_item_wrapper" key={`dummy_testimonial_${index}`}>
                  <TestimonialsCard image={item?.userImage?.data?.attributes?.url} designation={item?.designation} name={item?.userName} desc={item?.testimonial} isModal company={item?.company} />
                </div>;
          });
        }
        return <></>;
      default:
        return <></>;
    }
  };
  const handleLeftClick = () => {
    if (element) element.scrollLeft -= 300;
  };
  const handleRighClick = () => {
    if (element) {
      element.scrollLeft += 300;
    }
  };
  useEffect(() => {
    if (videoRef.current && activeIndex && touched) {
      videoRef.current?.play();
    }
  }, [activeIndex]);
  const handleVideoClick = (index: number) => {
    if (!touched) {
      settouched(true);
    }
    if (playing) {
      videoRef.current?.pause();
      if (index !== activeIndex) {
        setplaying(index);
        setActiveIndex(index);
        return;
      }
      setplaying(0);
      setActiveIndex(0);
      return;
    } else {
      setplaying(index);
      setActiveIndex(index);
      if (index === activeIndex) {
        videoRef?.current?.play();
      }
    }
  };
  const handleSeeAllClick = async () => {
    let response;
    switch (type) {
      case "SUCCESSSTORY":
        response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getTransitions()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
        break;
      case "VIDEOCARD":
        response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getVideoTestimonials()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
        break;
      case "TESTIMONIAL":
        response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getTestimonials()).then((resp: any) => resp.json()).catch((error: any) => error?.response);
        break;
    }
    const skipCount = type === "VIDEOCARD" ? 5 : 4;
    const rest = response.data.slice(skipCount);
    setrestData(rest);
    setShowModal(true);
  };
  const getCard = (item: any, index: number) => {
    switch (type) {
      case "VIDEOCARD":
        return <VideoTestimonial name={item.userName} ref={videoRef} designation={item.designation} image={item.videoTestimonial?.data?.attributes?.url ?? item.userImageUrl ?? item.userImage.data.attributes.url} videoIndex={index + 1} activeIndex={activeIndex} setIndex={setActiveIndex} playing={playing === index + 1} handleClick={handleVideoClick} />;
      case "SUCCESSSTORY":
        return <SuccessStoryCard learnerDetails={item} clickHandler={() => handleSeeAllClick()} />;
      case "TESTIMONIAL":
        return <TestimonialsCard image={item?.userImage?.data?.attributes?.url} designation={item.designation} name={item.userName} desc={item.testimonial} clickHandler={() => handleSeeAllClick()} company={item?.company} />;
    }
  };
  return <>
      <div className="testimonials_section_wrapper">
        <SectionHeader text={title} isSeeAll={type !== "VIDEOCARD"} handleSeeAll={() => {
        if (type !== "VIDEOCARD") handleSeeAllClick();
      }} isTestimonial showButtons disableLeft={scrollState.disableLeft} disableRight={scrollState.disableRight} handleLeftClick={handleLeftClick} handleRightClick={handleRighClick} data-sentry-element="SectionHeader" data-sentry-source-file="index.tsx" />
        <div className="testimonial_items_wrapper" ref={setElement}>
          {data?.data.map((item: any, index: number) => {
          return <div className="item_testimonial" key={`item_${index}`} onClick={() => {
            if (type !== "VIDEOCARD") handleSeeAllClick();
          }} ref={index === data.data.length - 1 ? testimonialRef : null}>
                {getCard(item?.attributes, index)}
              </div>;
        })}
          {showAll && restData.map((item: any, index: number) => {
          return <div className="item_testimonial" key={`item_${index}`} onClick={() => {
            if (type !== "VIDEOCARD") handleSeeAllClick();
          }}>
                  {getCard(item?.attributes, index)}
                </div>;
        })}
        </div>
      </div>
      {showmodal && <SideModal clickHandler={() => setShowModal(false)}>
          <div className="testimonials_modal_content_wrapper">
            <div className="testimonials_modal_content_header_wrapper">
              {isMobile && <img src={projectImages.LeftArrowCircledDark} loading="lazy" alt="back" onClick={() => setShowModal(false)} />}
              <TypoGraphy text={title} variant={isMobile ? "Condensed/Mobile/Heading 1 | M | 24 | 140" : "Condensed/Desktop/Heading 1 | M | 32 | 140"} />
            </div>
            <div className="testimonials_modal_content">{getModalData()}</div>
          </div>
        </SideModal>}
    </>;
};
export default TestimonialsSection;